
import {initWebComponent} from "@/helpers/web-component-helper";
import {WizardComponent} from "@/components/wizard/wizard-component";
import {WizardNavItemComponent} from "@/components/wizard/wizard-nav-item-component";
import {getDomainListItems} from "@/http/services/http-services-domainlist";

const template = document.createElement('template');

export class FormDomainListSingleComponent extends HTMLElement {
    constructor() {
        super();
        const attributeID = this.getAttribute('data-attribute-id')
        const name = this.getAttribute('data-name')
        const isRequired = this.getAttribute('data-is-required')
        const key = this.getAttribute('data-key')

        let innerHtml = `
            <h2 class="text-primary">` + name + `${isRequired}</h2>
            <div class="form-group text-primary mb-4">`

        if(window.domainListItems[key] && window.domainListItems[key].length > 0) {
            window.domainListItems[key].map( (domainListItem, key) => {
                innerHtml += '<form-domain-list-item data-parent-name="undefined" data-value="' + domainListItem.Value + '" data-image="'+ domainListItem.Image + '" data-attribute-id="'+ attributeID + '" data-name="' + domainListItem.Name + '"></form-domain-list-item>'
            })
            innerHtml += `
                <small class="invalid-feedback">
                    Dit veld is verplicht
                </small>
             </div>`

            template.innerHTML = innerHtml

            initWebComponent(this, template)
        } else {


            let data = {}
            let wizardChildItem
            let wizardItem
            let distance

            window.wizard.Items.map( item => {
                item.Items.map( childItem => {
                    if( childItem.AttributeID === parseInt(attributeID) && childItem.AttributeTypeID !== null) {
                        wizardChildItem = childItem
                        wizardItem = item
                        distance = childItem.LinkedLayer.distance
                    }
                })
            })

            if(distance) {
                return
            }

            data = {
                columnName: wizardChildItem.Attribute,
                column: wizardChildItem.FormAttributeID
            }
            const parentElement =  document.querySelector('.list-item-hoofdcategorie.active')
            if(parentElement) {
                data.parentValue = parentElement.closest('form-domain-list-item').dataset.value
            }

            getDomainListItems(wizardItem.ID, data).then(result => {
                return result.json()
            }).then(result => {

                if(result.features.length === 0) {
                    return
                }

                result.features.map( feature => {

                    let comment = ''
                    if(feature.properties.opmerking) {
                        comment = feature.properties.opmerking
                    }

                    innerHtml += `<form-domain-list-item data-comment="${comment}" data-child-name="${feature.properties.attr.child_name}" data-parent-name="${feature.properties.attr.parent_name}" data-name="${feature.properties.name}" data-value="${feature.properties.value}"  data-attribute-id="${attributeID}"></form-domain-list-item>`
                })
                innerHtml += `
                    <small class="invalid-feedback">
                        Dit veld is verplicht
                    </small>
                 </div>`
                template.innerHTML = innerHtml

                initWebComponent(this, template)
            })
        }
    }
}
